__turbopack_context__.v({
  "categorySection": "IndiaDynamicContent-module__UKGixG__categorySection",
  "categorySeparator": "IndiaDynamicContent-module__UKGixG__categorySeparator",
  "categoryTitle": "IndiaDynamicContent-module__UKGixG__categoryTitle",
  "contentLayout": "IndiaDynamicContent-module__UKGixG__contentLayout",
  "errorContainer": "IndiaDynamicContent-module__UKGixG__errorContainer",
  "mainContent": "IndiaDynamicContent-module__UKGixG__mainContent",
  "mobileComparisonCTA": "IndiaDynamicContent-module__UKGixG__mobileComparisonCTA",
  "mobileComparisonCloseButton": "IndiaDynamicContent-module__UKGixG__mobileComparisonCloseButton",
  "mobileComparisonContainer": "IndiaDynamicContent-module__UKGixG__mobileComparisonContainer",
  "mobileComparisonContent": "IndiaDynamicContent-module__UKGixG__mobileComparisonContent",
  "mobileGenderOption": "IndiaDynamicContent-module__UKGixG__mobileGenderOption",
  "mobileGenderOptionText": "IndiaDynamicContent-module__UKGixG__mobileGenderOptionText",
  "mobileGenderOptions": "IndiaDynamicContent-module__UKGixG__mobileGenderOptions",
  "mobileGenderSection": "IndiaDynamicContent-module__UKGixG__mobileGenderSection",
  "mobileGenderTitle": "IndiaDynamicContent-module__UKGixG__mobileGenderTitle",
  "mobileHeader": "IndiaDynamicContent-module__UKGixG__mobileHeader",
  "mobileRadioButton": "IndiaDynamicContent-module__UKGixG__mobileRadioButton",
  "otherTestsPlansGrid": "IndiaDynamicContent-module__UKGixG__otherTestsPlansGrid",
  "plansComparisonSeparator": "IndiaDynamicContent-module__UKGixG__plansComparisonSeparator",
  "plansGrid": "IndiaDynamicContent-module__UKGixG__plansGrid",
});
